"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CurrentFastenersGroup_1 = __importDefault(require("./CurrentFastenersGroup"));
exports.default = CurrentFastenersGroup_1.default;
